import * as React from 'react'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { cn } from '@/lib/utils'

// Base UI radio needs a RadioGroup context around the items, so we expose both:
// OdinRadioGroup owns the value/onChange, OdinRadio is a single value+label item.
export type OdinRadioGroupProps = {
  value?: string
  onChange?: (value: string) => void
  disabled?: boolean
  className?: string
  children: React.ReactNode
}

export function OdinRadioGroup({ value, onChange, disabled, className, children }: OdinRadioGroupProps) {
  return (
    <RadioGroup
      value={value}
      onValueChange={(next) => onChange?.(next as string)}
      disabled={disabled}
      className={className}
    >
      {children}
    </RadioGroup>
  )
}

export type OdinRadioProps = {
  value: string
  label?: string
  disabled?: boolean
  className?: string
}

export function OdinRadio({ value, label, disabled, className }: OdinRadioProps) {
  const id = React.useId()
  return (
    <label
      htmlFor={id}
      className={cn(
        'flex items-center gap-2 text-sm',
        disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
        className,
      )}
    >
      <RadioGroupItem id={id} value={value} disabled={disabled} />
      {label && <span>{label}</span>}
    </label>
  )
}
